import React from 'react';
import * as types from '../../../store/constants';
import { StButton, StDisabledButton } from '../../../shared/common/NumberSpinner.styled';

interface Props {
    value: number;
    min?: number;
    onChange: (type: string, value: number) => void;
    className?: string;
}

export function RenewalCopyCounter({ onChange, min = 0, className, value }: Props) {
    function onDecrease() {
        onChange(types.ACTION_DECREASE, 1);
    }

    function onIncrease() {
        onChange(types.ACTION_INCREASE, 1);
    }

    return (
        <div className={className}>
            {value > min ? <StButton onClick={onDecrease}>-</StButton> : <StDisabledButton>-</StDisabledButton>}
            <span>{value}</span>
            {<StButton onClick={onIncrease}>+</StButton>}
        </div>
    );
}
